import React from 'react';
import {withScriptjs, withGoogleMap, GoogleMap, Marker} from 'react-google-maps';

const map = withScriptjs(withGoogleMap((props) =>
    <GoogleMap
        defaultZoom={18}
        defaultCenter={{lat: 59.122985, lng: 11.386277}}
        >
        {props.isMarkerShown && <Marker position={{ lat: 59.122985, lng: 11.386277 }} />}
    </GoogleMap>
));

export default map;


// WEBPACK FOOTER //
// ./src/components/Map/Map.js